// src/utils/tipoEntregaUtils.js
const normalizarDescricaoTipoEntrega = (descricao) => String(descricao || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase();

export const tipoEntregaTemTaxa = (tipoEntrega) => {
  if (typeof tipoEntrega?.temTaxaEntrega === 'boolean') {
    return tipoEntrega.temTaxaEntrega;
  }

  // Compatibilidade com seleções antigas salvas antes de a flag ser persistida no navegador.
  return normalizarDescricaoTipoEntrega(tipoEntrega?.descricao) === 'delivery';
};

export const tipoEntregaEhConsumoLocal = (tipoEntrega) =>
  normalizarDescricaoTipoEntrega(tipoEntrega?.descricao) === 'consumir no local';
